export const apiVersion = {
    major: 12,
    minor: 0,
};
